import { useCallback } from 'react';

type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastOptions {
  duration?: number;
  position?: 'top' | 'bottom';
}

export const useToast = () => {
  const showToast = useCallback((type: ToastType, message: string, options?: ToastOptions) => {
    // TODO: Implement toast notification system
    console.log(`[Toast: ${type}] ${message}`, options);
  }, []);

  return { showToast };
}; 